export default "__VITE_ASSET__a2b9cb59__"